import React from 'react';

// Kein Object.entries, kein Spread auf evtl. null.
export default function HistoryList({
  entries,
  update,
  remove,
  userColors,
  selectedIds,
  onToggleSelect,
  onRedeem
}) {
  const list = Array.isArray(entries) ? entries : [];
  const colors = (userColors && typeof userColors === 'object') ? userColors : {};
  const selected = (selectedIds instanceof Set) ? selectedIds : new Set();
  const onToggle = typeof onToggleSelect === 'function' ? onToggleSelect : () => {};
  const doRedeem = typeof onRedeem === 'function' ? onRedeem : () => {};
  const doRemove = typeof remove === 'function' ? remove : () => {};

  if (!list.length) {
    return <div className="pfp-history-empty-list">Keine Eintraege im Zeitraum.</div>;
  }

  return (
    <ul className="history-list">
      {list.map((e) => {
        if (!e) return null;
        const isOpen = (e.status === undefined || e.status === null) ? 'open' : e.status;
        const isSelected = selected.has(e.id);
        const color = colors && colors[e.user_id] ? colors[e.user_id] : '#d8a24c';
        const amount = Number(e.amount || 0).toFixed(2).replace('.', ',');
        const dateLabel = e.timestamp ? new Date(e.timestamp).toLocaleString() : '-';
        const quantity = Number(e.quantity || 1);
        const packageLabel = e.package_label || '';
        const packageText = packageLabel
          ? `${quantity > 1 ? `${quantity} x ` : ''}${packageLabel}`
          : '';

        return (
          <li key={e.id} className={`history-list-item ${isSelected ? 'is-selected' : ''}`} style={{ '--history-accent': color }}>
            <label className="pfp-history-check">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => onToggle(e.id)}
                aria-label={`Eintrag ${e.id} auswaehlen`}
              />
              <span aria-hidden="true" />
            </label>

            <div className="pfp-history-entry-main">
              <strong>{amount} Euro</strong>
              <span>{dateLabel}</span>
              {e.product_name ? <em>{e.product_name}</em> : null}
              {packageText ? <small>{packageText}</small> : null}
            </div>

            <div className="pfp-history-entry-actions">
              {isOpen === 'open' ? (
                <button className="pfand-button" onClick={() => doRedeem(e.id)}>Einloesen</button>
              ) : (
                <span className="pfp-history-status">eingeloest</span>
              )}
              <button
                className="pfp-history-delete"
                onClick={() => doRemove(e.id)}
                title="Loeschen"
                aria-label="Eintrag loeschen"
              >
                x
              </button>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
